import { Box, Stack, Typography, IconButton, Dialog, TextField } from "@mui/material";
import { DeleteForever, Edit } from "@mui/icons-material";
import React, { useState } from "react";
import { useEffect } from "react";

export default function BilletInfoSection({ billet, rmBillet, setBillet, event, index }) {
    
    useEffect(()=> {
        if(event.tarifs.filter(t => t.type === 'guichet').length > 0 && !event.tarifs.find(t => t.nom === billet.tarif)) {
            const higherTarif = event.tarifs.filter(t => t.type === 'guichet').reduce((prev, current) => (prev.montant > current.montant) ? prev : current);
            setBillet({...billet, tarif: higherTarif.nom, price: higherTarif.montant})
        } else if(!event.tarifs.find(t => t.nom === billet.tarif)) {
            setBillet({...billet, tarif: event.tarifs[0].nom, price: event.tarifs[0].montant})
        }
    }, [event])


    return <Box sx={{display: 'flex', flexDirection: 'column', gap: 2, py: 2, px:{xs: 1, sm: 2}}}>
        <Stack direction={{ xs: 'column', md: 'row' }} spacing={4} alignItems="center" justifyContent={'space-between'}>
            <Stack direction="row" spacing={{xs: 1, sm: 2}} alignItems="center">
                <IconButton onClick={rmBillet} sx={{color:'alerte.main'}}>
                    <DeleteForever />
                </IconButton>
                <Box>

                    <Stack direction={{ xs: 'column', md: 'row' }} spacing={1} alignItems='center' mt={1}>
                        <Typography variant="body1" fontSize={14} sx={{whiteSpace: 'nowrap'}}>billet au nom de </Typography>
                        <TextField required placeholder="nom" value={billet.owner?.nom} onChange={(e) => setBillet({...billet, owner: {...billet.owner, nom: e.target.value}})} size='small' 
                        variant='filled' fullWidth sx={{minWidth: '100px', '& .MuiFilledInput-input': {py: 0.5}}} slotProps={{input: {style: {borderRadius: 0, height: '30px', fontSize:16}}}} />
                        <TextField required placeholder="prénom" value={billet.owner?.prenom} onChange={(e) => setBillet({...billet, owner: {...billet.owner, prenom: e.target.value}})} size='small' 
                        variant='filled' fullWidth sx={{minWidth: '100px', '& .MuiFilledInput-input': {py: 0.5}}} slotProps={{input: {style: {borderRadius: 0, height: '30px', fontSize:16}}}} />
                    </Stack>
                </Box>
            </Stack>

            {!!event && <TextField select label="Tarif" color='focus' value={billet.tarif} required size='small' slotProps={{select: {native: true}, inputLabel: {shrink: true}}}
            sx={{minWidth: '250px', width:'30%'}} fullWidth onChange={(e) => setBillet({...billet, tarif: e.target.value, price: event.tarifs.find(t => t.nom === e.target.value)?.montant || 0})}>
                <option value="" disabled={true}>Sélectionner un tarif</option>
                {(event.tarifs.filter(t => t.type === 'guichet').length > 0 ? event.tarifs.filter(t => t.type === 'guichet') : event.tarifs).map((tarif) => (
                    <option key={tarif._id} value={tarif.nom}>{tarif.nom+' - '+tarif.montant?.toFixed(2)} €</option>
                ))}
            </TextField>}

        </Stack>
    </Box>
}